const types = {
  //Get Template name
  GET_EQUIPMENTS_START: "GET_EQUIPMENTS_START",
  GET_EQUIPMENTS_SUCCESS: "GET_EQUIPMENTS_SUCCESS",
  GET_EQUIPMENTS_ERROR: "GET_EQUIPMENTS_ERROR",
  GET_EQUIPMENTS_RESET: "GET_EQUIPMENTS_RESET",

  //Create Template name
  CREATE_EQUIPMENTS_START: "CREATE_EQUIPMENTS_START",
  CREATE_EQUIPMENTS_SUCCESS: "CREATE_EQUIPMENTS_SUCCESS",
  CREATE_EQUIPMENTS_ERROR: "CREATE_EQUIPMENTS_ERROR",
  CREATE_EQUIPMENTS_RESET: "CREATE_EQUIPMENTS_RESET",

  //delete Template name
  DELETE_EQUIPMENTS_START: "DELETE_EQUIPMENTS_START",
  DELETE_EQUIPMENTS_SUCCESS: "DELETE_EQUIPMENTS_SUCCESS",
  DELETE_EQUIPMENTS_ERROR: "DELETE_EQUIPMENTS_ERROR",
  DELETE_EQUIPMENTS_RESET: "DELETE_EQUIPMENTS_RESET",

  //update Template name
  UPDATE_EQUIPMENTS_START: "UPDATE_EQUIPMENTS_START",
  UPDATE_EQUIPMENTS_SUCCESS: "UPDATE_EQUIPMENTS_SUCCESS",
  UPDATE_EQUIPMENTS_ERROR: "UPDATE_EQUIPMENTS_ERROR",
  UPDATE_EQUIPMENTS_RESET: "UPDATE_EQUIPMENTS_RESET",

  //single item  name
  SINGLE_EQUIPMENTS_START: "SINGLE_EQUIPMENTS_START",
  SINGLE_EQUIPMENTS_SUCCESS: "SINGLE_EQUIPMENTS_SUCCESS",
  SINGLE_EQUIPMENTS_ERROR: "SINGLE_EQUIPMENTS_ERROR",
  SINGLE_EQUIPMENTS_RESET: "SINGLE_EQUIPMENTS_RESET",
};

export default types;
